export const getCardTypeIcon = (cardType: string) => {
  switch (cardType) {
    case 'Visa':
      return '/icons/visa.svg'
    case 'MasterCard':
      return '/icons/mastercard.svg'
    case 'AmericanExpress':
      return '/icons/amex.svg'
    case 'Discover':
      return '/icons/discover.svg'
    case 'Diners':
      return '/icons/diners.svg'
    case 'JCB':
      return '/icons/jcb.svg'
    default:
      return '/icons/unknown.svg'
  }
}
